import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../api/auth';
import { useAuthStore } from '../stores/auth.store';

export function useAuth() {
  const navigate = useNavigate();
  const { user, isAuthenticated, login, logout: clearAuth } = useAuthStore();

  const doLogin = useCallback(async (username: string, password: string) => {
    const { data } = await authApi.login(username, password);
    const payload = data.data;
    login(payload.user, payload.accessToken, payload.refreshToken);
    navigate('/', { replace: true });
  }, [login, navigate]);

  const doLogout = useCallback(async () => {
    try {
      await authApi.logout();
    } catch {
      // Ignore network errors when logging out.
    }
    clearAuth();
    navigate('/login', { replace: true });
  }, [clearAuth, navigate]);

  return {
    user,
    isAuthenticated,
    doLogin,
    doLogout,
  };
}
